<template>
  <div>
    <v-container grid-list-lg>
      <v-layout row wrap>
        <information-view v-for="i in informations" v-bind:key="i.id" v-bind:information="i"></information-view>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
  import {
    mapGetters,
    mapActions
  } from 'vuex';
  import Information from '../../../store/models/Information.js';
  import InformationView from './InformationView.vue';

  export default {
    components: {
      InformationView
    },
    data() {
      return {};
    },
    computed: {
      ...mapGetters({
        loading: "getLoading",
        informations: "getInformations"
      })
    },
    created: function () {
      this.$store.dispatch("getAllInformations");
    }
  }

</script>
